<script lang="ts">
	import { getContext } from "svelte";
	import type { Readable } from "svelte/store";

	export let action: string;

	const permissions: Readable<Set<string>> = getContext("permissions");
</script>

{#if $permissions.has(action)}
	<slot />
{:else}
	<slot name="fallback" />
{/if}
